import React from 'react'
import './naglowek-filtrow.css'

/** Nazwa modułu obok logo — ten sam krój i odstęp w każdym module. */
export const NazwaModulu: React.FC<{ nazwa: string }> = ({ nazwa }) => <span className="nf-modul">{nazwa}</span>
